const LOAD_DATA_FIELD_OF_STUDY           = 'LOAD_DATA_FIELD_OF_STUDY'
const LOAD_DATA_FIELD_OF_STUDY_SUCCESS   = 'LOAD_DATA_FIELD_OF_STUDY_SUCCESS'
const LOAD_DATA_FIELD_OF_STUDY_FAILED    = 'LOAD_DATA_FIELD_OF_STUDY_FAILED'
const UNMOUNT_DATA_FIELD_OF_STUDY        = 'UNMOUNT_DATA_FIELD_OF_STUDY'

const initialState = {
  loading: true,
  data: null,
  message: null,
  pagination: {
    page: 1,
    total: 0,
    perpage: 10
  }
}

const fieldOfStudyReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_FIELD_OF_STUDY:
      return {
        ...state,
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case LOAD_DATA_FIELD_OF_STUDY_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        pagination: {
          total: action.payload.pagination.total,
          page: action.payload.pagination.page,
          perpage: action.payload.pagination.perpage
        }
      }
    case LOAD_DATA_FIELD_OF_STUDY_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case UNMOUNT_DATA_FIELD_OF_STUDY:
      return { 
        ...state, 
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    default:
      return state
  }
}

export default fieldOfStudyReducer;